export enum EngagementDocumentCounterParty {
    VetValue = 0,
    Seller = 1,
    Buyer = 2,
}

export const EngagementDocumentCounterPartyOptions = {
    [EngagementDocumentCounterParty.VetValue]: 'VetValue',
    [EngagementDocumentCounterParty.Seller]: 'Seller',
    [EngagementDocumentCounterParty.Buyer]: 'Buyer',
};